





















import { Vue, Component, Prop } from 'vue-property-decorator';
import { Button, Dialog, Toast, Popup } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import { needSmoothCheck, vote } from '@/api/api.ts';
import { ProgramVote, PersonalVote } from '../api';
import SlideVerify from '@/components/SlideVerify.vue';
Vue.use(Popup)
  .use(Dialog)
  .use(Toast)
  .use(Button);
@Component({
  components: {
    SlideVerify,
  },
})
export default class VoteButton extends Vue {
  @Prop() voteName!: string;
  @Prop() votes!: any;
  @Prop() voteWeChat!: boolean;
  @Prop({ default: 10 }) MaxNum!: number;
  @Prop({
    default: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews',
  })
  downLoadUrl!: string;
  @Prop() type!: string;
  SlideShow = false;
  pointOut = false;
  unionId!: string | null;
  startVote() {
    // 开始投票，判断是不是必须在app内投票
    if (this.voteWeChat && isWeiXin()) {
      this.unionId = window.localStorage.getItem('unionid');
      const data = {
        unionid: this.unionId,
      };
      // ProgramVote(this.voteName, this.votes, data).then((result: any) =>
      //   this.successVote(result),
      // );
    } else if (window.udid) {
      const data = {
        udid: window.udid,
        appkey: window.appkey,
      };
      if (this.type === 'personal') {
        if (this.votes.length === 0) {
          Toast('至少选择一位最佳演员，方可提交');
          return;
        }
        // const r = this.votes.filter((s: any) => {
        //   return s && s.trim();
        // });
        // console.log(r);
        PersonalVote(this.voteName, this.votes, data).then((result: any) =>
          this.successVote(result),
        );
      } else {
        if (this.votes.length !== 7) {
          Toast('需为每个奖项选出您所喜爱的节目，方可提交');
          return;
        }
        ProgramVote(this.voteName, this.votes, data).then((result: any) =>
          this.successVote(result),
        );
      }
    } else {
      Dialog.confirm({
        title: '友情提示',
        message: '请在上游新闻App进行投票',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        closeOnClickOverlay: true,
      })
        .then(() => {
          window.location.href = this.downLoadUrl;
        })
        .catch(() => {
          if (isWeiXin() === true) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
    }
  }
  fSlideData(res: object) {
    this.SlideShow = false;
    if (this.voteWeChat && isWeiXin()) {
      const data = {
        unionid: this.unionId,
      };
      const lastData = Object.assign(res, data);
      // ProgramVote(this.voteName,this.votes, lastData).then((result: any) =>
      //   this.successVote(result),
      // );
    } else if (window.udid) {
      const data = {
        udid: window.udid,
        appkey: window.appkey,
      };
      const lastData = Object.assign(res, data);
      if (this.type === 'personal') {
        PersonalVote(this.voteName, this.votes, lastData).then((result: any) =>
          this.successVote(result),
        );
      } else {
        if (this.votes.length !== 7) {
          Toast('请选择7个节目');
          return;
        }
        ProgramVote(this.voteName, this.votes, lastData).then((result: any) =>
          this.successVote(result),
        );
      }
    } else {
      Dialog.confirm({
        title: '友情提示',
        message: '请在上游新闻App进行投票',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        closeOnClickOverlay: true,
      })
        .then(() => {
          window.location.href = this.downLoadUrl;
        })
        .catch(() => {
          if (isWeiXin() === true) {
            this.pointOut = true;
          } else {
            window.location.href =
              'shangyounews://{"dt":"7","url":"' +
              document.location.href +
              '"}';
          }
        });
    }
  }
  successVote(res: any) {
    switch (res.code) {
      case 200:
        Toast({
          type: 'success',
          duration: 1200,
          message: res.msg,
        });
        this.$emit('votSuccess', res.data);
        break;
      case 201:
        this.SlideShow = true;
        break;
      case 202:
        if (parseFloat(window.version) >= 4.5) {
          window.handleMessage('{"action":"mUserLogin","data":""}');
        } else {
          window.location.href = 'client:logout';
        }
        break;
      case 500:
        Toast.fail(res.msg);
        break;
      case 203:
        if (this.voteWeChat && isWeiXin()) {
          Dialog.confirm({
            title: '友情提示',
            message: `投票次数已满，打开上游新闻app可再获得${this.MaxNum}次投票机会`,
            confirmButtonText: '还没装？一步安装',
            cancelButtonText: '我已安装过',
            closeOnClickOverlay: true,
          })
            .then(() => {
              window.location.href = this.downLoadUrl;
            })
            .catch(() => {
              if (isWeiXin() === true) {
                this.pointOut = true;
              } else {
                window.location.href =
                  'shangyounews://{"dt":"7","url":"' +
                  document.location.href +
                  '"}';
              }
            });
        } else {
          Toast.fail(res.msg);
        }
        break;
      case 204:
        Toast.fail(res.msg);
        break;
      case 300:
        Toast.fail(res.msg);
        break;
      case 101:
        Toast.fail(res.msg);
        break;
    }
  }
}
